module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-34.e2939753.png";